export default function Settings(){return <div className='p-8'>Settings</div>}